import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandCircleDown from "@mui/icons-material/ExpandCircleDown";
import { Grid, Theme, useMediaQuery } from "@mui/material";
import { useAppSelector } from "../../app/store/configureStore";

export default function Learning() {
  const { user } = useAppSelector((state) => state.account);

  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );

  return (
    <Grid item xs={12} px={3} pt={3}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandCircleDown className="blue-expand-icon" />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="body1" fontWeight="bold">
            Learning Experience Example - Do Not Copy
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3} p={1}>
            <Grid item xs={isMobile ? 12 : 6}>
              <Typography fontWeight={700}>
                {user?.credentialTypeId === 4
                  ? "*Title"
                  : "Learning Experience Title"}
              </Typography>
              <Typography>
                {user?.credentialTypeId === 4
                  ? "Drawing Activity"
                  : "Water Table Activity"}
              </Typography>
            </Grid>
            <Grid item xs={isMobile ? 12 : 6}>
              <Typography fontWeight={700}>*Age Group</Typography>
              <Typography>{user?.credentialName}</Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography fontWeight={700}>
                {user?.credentialTypeId === 4
                  ? "Intended Goals"
                  : "Intended Goals - What will children experience or learn?"}
              </Typography>

              <Typography component="div">
                {user?.credentialTypeId === 4 ? (
                  "To help parents expand their child's vocabulary (Emergent Literacy)"
                ) : (
                  <ul>
                    <Typography>During this activity:</Typography>
                    <li>Children will have water sensory experience</li>
                    <li>
                      Children will observe different amounts of water and the
                      effects of water on other objects
                    </li>
                  </ul>
                )}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography fontWeight={700}>
                {user?.credentialTypeId === 4
                  ? "*Materials:"
                  : "*Materials - What do you need to complete the activity?"}
              </Typography>
              <Typography>
                {user?.credentialTypeId === 4
                  ? "Paper, crayons"
                  : "Water table, water-proof containers of different sizes and shapes, pieces of paper, and fabric"}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography fontWeight={700}>
                {user?.credentialTypeId === 4
                  ? "*Process/Teaching Strategies:"
                  : "*Process/Teaching strategies - How will you complete the activity?"}
              </Typography>
              <Typography component="div">
                {user?.credentialTypeId === 4 ? (
                  <ul>
                    <li>
                      Suggest to parents they have their child draw a picture of
                      what they saw at an event or place they went and ask the
                      child to tell them about it using open-end questions such
                      as “What is in your drawing?”
                    </li>
                    <li>
                      Have the parents record the child's words and keywords on
                      a separate sheet of paper and provide praise for the
                      child's drawing and words.
                    </li>
                    <li>
                      As the home visitor, I will then discuss how the parents
                      can reinforce and extend the child's vocabulary with those
                      words.
                    </li>
                  </ul>
                ) : (
                  <ul>
                    <li>
                      Children will pour water into containers and onto
                      different objects (e.g., cloth, paper, plastic toys)
                    </li>
                    <li>
                      The teacher will talk with the children about amounts of
                      water and how water affects these different objects
                      (movement, changing shape/texture)
                    </li>
                  </ul>
                )}
              </Typography>
            </Grid>
            {user?.credentialTypeId !== 4 && (
              <Grid item xs={12}>
                <Typography fontWeight={700}>
                  Developmentally Appropriate - How is this experience
                  developmentally appropriate?
                </Typography>
                <Typography>
                  This learning experience is developmentally appropriate for
                  children in this age group because they are old enough to pour
                  water and think about different amounts of water and
                  whether/how water affects different objects.
                </Typography>
              </Grid>
            )}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
}
